// const baseUrlMaster = "https://6167e749ba841a001727c49f.mockapi.io/api";
// const baseUrlMaster = "https://localhost:44320/api/MasterApi";

// PTT Servertest
// export const baseUrl = "https://tsoopwb.pttplc.com/";//test
// export const baseUrl = "https://tsoreport.pttplc.com/";//production
// console.log(process.env)
export const baseUrl = process.env.REACT_APP_BASE_API_URL + "/";//production
// export const baseUrl = "http://26.210.246.220/";
const baseUrlMaster = baseUrl + "api/MasterApi";
const baseUrlMeter = baseUrl + "api/MeterApi";
const baseUrlInputManagement = baseUrl + "api/UploadFile";
const baseUrlFlowSelection = baseUrl + "api/FlowSelect";
const baseUrlManualData = baseUrl + "api/ManualData";
const baseUrlAlarmReport = baseUrl + "api/AlarmReport";
const baseUrlPMISApi = baseUrl + "api/PMISApi";
const baseUrlAccount = baseUrl + "api/Account";
const baseUrlSummaryReport = baseUrl + "api/Report";
// PTT Servertest

//MASTER DATA SETTING => OTHER

// PAGE CUSTOMER TYPE
export const GET_CUSTOMER_TYPE = baseUrlMaster + "/getCustomerType";
export const ADD_CUSTOMER_TYPE = baseUrlMaster + "/saveCustomerType";
export const DELETE_CUSTOMER_TYPE = baseUrlMaster + "/delCustomerType";
//PAGE CUSTOMER TYPE

// PAGE ZONE
export const GET_ZONE = baseUrlMaster + "/getZone";
export const ADD_ZONE = baseUrlMaster + "/saveZone";
export const DELETE_ZONE = baseUrlMaster + "/delZone";
//PAGE ZONE

// PAGE POINT
export const GET_POINT = baseUrlMaster + "/getPoint";
export const ADD_POINT = baseUrlMaster + "/savePoint";
export const DELETE_POINT = baseUrlMaster + "/delPoint";
// PAGE POINT

// PAGE REGION
export const GET_REGION = baseUrlMaster + "/getRegion";
export const ADD_REGION = baseUrlMaster + "/saveRegion";
export const DELETE_REGION = baseUrlMaster + "/delRegion";
//PAGE REGION

// PAGE NOMINATION
export const GET_NOMINATION = baseUrlMaster + "/getNominate";
export const ADD_NOMINATION = baseUrlMaster + "/saveNominate";
export const DELETE_NOMINATION = baseUrlMaster + "/delNominate";
//PAGE NOMINATION

// PAGE AREA
export const GET_AREA = baseUrlMaster + "/getArea";
export const ADD_AREA = baseUrlMaster + "/saveArea";
export const DELETE_AREA = baseUrlMaster + "/delArea";
//PAGE AREA

// PAGE SUB AREA
export const GET_SUB_AREA = baseUrlMaster + "/getSubArea";
export const ADD_SUB_AREA = baseUrlMaster + "/saveSubArea";
export const DELETE_SUB_AREA = baseUrlMaster + "/delSubArea";
//PAGE SUB AREA

// PAGE BLOCK VALVE
export const GET_BVVALVE = baseUrlMaster + "/getBvValue";
export const ADD_BVVALVE = baseUrlMaster + "/saveBvValue";
export const DELETE_BVVALVE = baseUrlMaster + "/delBvValue";
//PAGE BLOCK VALVE

// PAGE BVZONE
export const GET_BVZONE = baseUrlMaster + "/getBvZone";
export const ADD_BVZONE = baseUrlMaster + "/saveBVZone";
export const DELETE_BVZONE = baseUrlMaster + "/delBvZone";
//PAGE BVZONE

// PAGE INDUSTRIALESTATE
export const GET_INDUS = baseUrlMaster + "/getEState";
export const ADD_INDUS = baseUrlMaster + "/saveEState";
export const DELETE_INDUS = baseUrlMaster + "/delEState";
//PAGE INDUSTRIALESTATE

// PAGE QUALITYPOINT
export const GET_QTYPOINT = baseUrlMaster + "/getQtyPoint";
export const ADD_QTYPOINT = baseUrlMaster + "/saveQtyPoint";
export const DELETE_QTYPOINT = baseUrlMaster + "/delQtyPoint";
//PAGE QUALITYPOINT

// PAGE REMARK1
export const GET_REMARK1 = baseUrlMaster + "/getRemark1";
export const ADD_REMARK1 = baseUrlMaster + "/saveRemark1";
export const DELETE_REMARK1 = baseUrlMaster + "/delRemark1";
//PAGE REMARK1

//PAGE REMARK2
export const GET_REMARK2 = baseUrlMaster + "/getRemark2";
export const ADD_REMARK2 = baseUrlMaster + "/saveRemark2";
export const DELETE_REMARK2 = baseUrlMaster + "/delRemark2";
//PAGE REMARK2

//PAGE REMARK3
export const GET_REMARK3 = baseUrlMaster + "/getRemark3";
export const ADD_REMARK3 = baseUrlMaster + "/saveRemark3";
export const DELETE_REMARK3 = baseUrlMaster + "/delRemark3";
//PAGE REMARK3

//PAGE REMARK4
export const GET_REMARK4 = baseUrlMaster + "/getRemark4";
export const ADD_REMARK4 = baseUrlMaster + "/saveRemark4";
export const DELETE_REMARK4 = baseUrlMaster + "/delRemark4";
//PAGE REMARK4

//PAGE REMARK5
export const GET_REMARK5 = baseUrlMaster + "/getRemark5";
export const ADD_REMARK5 = baseUrlMaster + "/saveRemark5";
export const DELETE_REMARK5 = baseUrlMaster + "/delRemark5";
//PAGE REMARK5

//MASTER DATA SETTING => OTHER

//MASTER DATA SETTING => VIRTUALMETER
export const GET_VIRTUAL_METER = baseUrlMeter + "/getVirtualMeter";
export const ADD_VIRTUAL_METER = baseUrlMeter + "/saveVirtualMeter";
export const DELETE_VIRTUAL_METER = baseUrlMeter + "/delVirtualMeter";
//MASTER DATA SETTING => VIRTUALMETER

//MASTER DATA SETTING => SHIPPER

// PAGE SHIPPER HEADER
export const GET_SHIPPER = baseUrlMaster + "/getCustomer";
export const ADD_SHIPPER = baseUrlMaster + "/saveCustomer";
export const DELETE_SHIPPER = baseUrlMaster + "/delCustomer";
// export const UPDATE_SHIPPER = baseUrlMaster + "/updateCustomer"
//PAGE SHIPPER HEADER

// PAGE SHIPPER DETAIL
export const GET_DETAIL_SHIPPER = baseUrlMaster + "/getCustomerContact";
export const ADD_DETAIL_SHIPPER = baseUrlMaster + "/saveCustomerContact";
export const DELETE_DETAIL_SHIPPER = baseUrlMaster + "/delCustomerContact";
export const UPDATE_DETAIL_MAIN_CONTACT = baseUrlMaster + "/setMainContact";
// export const UPDATE_DETAIL_SHIPPER  = baseUrlMaster + "/updateCusCont"
//PAGE SHIPPER DETAIL

//MASTER DATA SETTING => SHIPPER

//MASTER DATA SETTING => METER
export const GET_METER = baseUrlMeter + "/getMeter";
export const ADD_METER = baseUrlMeter + "/saveMeter";
export const DELETE_METER = baseUrlMeter + "/delMeter";
export const GET_ALL_SELECT = baseUrlMaster + "/getAllMasterCboList";
// export const UPDATE_SHIPPER = baseUrlMeter + "/updateMeter"
//MASTER DATA SETTING => METER

//INPUT MANAGEMENT (UPLOAD) => BOOKING
export const IMPORT_BOOKING = baseUrlInputManagement + "/importBooking";
export const GET_BOOKING_CONF = baseUrlInputManagement + "/getBookingConf";
export const DELETE_BOOKING_CONF = baseUrlInputManagement + "/delBookingConf";
export const GET_BOOKING_DATA = baseUrlInputManagement + "/getBookingData";

export const GET_SHIPPER_BY_BOOKING = baseUrlInputManagement + "/getShipperFromBooking";

//INPUT MANAGEMENT (UPLOAD) => BOOKING

//INPUT MANAGEMENT (UPLOAD) => NOMINATION(WEEK) AND (DAY)
export const IMPORT_NOMINATION_WEEK = baseUrlInputManagement + "/importWeeklyNominate";
export const IMPORT_NOMINATION_DAY = baseUrlInputManagement + "/importDayNominate";
export const GET_NOMINATION_CONF = baseUrlInputManagement + "/getNominateConf";
export const GET_NOMINATION_DATA = baseUrlInputManagement + "/getNominateData";
//INPUT MANAGEMENT (UPLOAD) => NOMINATION(WEEK) AND (DAY)

//INPUT MANAGEMENT (UPLOAD) => ALLOCATION
export const IMPORT_ALLOCATE = baseUrlInputManagement + "/importAllocate";
export const GET_ALLOCATE_CONF = baseUrlInputManagement + "/getAllocateConf";
export const GET_ALLOCATE_DATA = baseUrlInputManagement + "/getAllocateData";
//INPUT MANAGEMENT (UPLOAD) => ALLOCATION

//INPUT MANAGEMENT (UPLOAD) => METERING DAILY
export const IMPORT_METER_DAILY = baseUrlInputManagement + "/importDayMeter";
// export const IMPORT_METER_MONTH = baseUrlInputManagement + "/importMonthMeter";
export const GET_METER_CONF = baseUrlInputManagement + "/getUploadConf";
export const GET_METER_DATA = baseUrlInputManagement + "/getUploadData";
//INPUT MANAGEMENT (UPLOAD) => METERING DAILY

//INPUT MANAGEMENT (UPLOAD) => METERING MONTH
export const IMPORT_METER_MONTH = baseUrlInputManagement + "/importMonthMeter";
export const IMPORT_METER_MONTH_EX = baseUrlInputManagement + "/importMonthMeterEx";
export const GET_METER_MONTH_CONF = baseUrlInputManagement + "/getMonUploadConf";
export const GET_METER_MONTH_DATA = baseUrlInputManagement + "/getMonUploadData";
export const REFRESH_MONTHLY = baseUrlPMISApi + "/getAPIBillingMonthly";
//INPUT MANAGEMENT (UPLOAD) => METERING MONTH

export const GET_AREA_FROM_BOOKING = baseUrlInputManagement + "/getAreaFromBooking";
//FLOW SELECTION
export const GET_FLOW_CONF = baseUrlFlowSelection + "/getFlowConf";
export const GET_FLOW_DATA = baseUrlFlowSelection + "/getFlowData";
export const CHANGE_DATA_ON_SELECT = baseUrlInputManagement + "/getOtherDataSource";
export const CREATE_NEW_REVISION = baseUrlFlowSelection + "/createNewRevision";
export const SAVE_STATUS_AND_DETAIL = baseUrlFlowSelection + "/saveStatusAndDetail";
export const SAVE_LIST_FLOW_DATA = baseUrlFlowSelection + "/saveListFlowData";
export const AUTO_CAL = baseUrlFlowSelection + "/autoCalFlowSelectFromDate";
export const AUTO_EX_CAL = baseUrlFlowSelection + "/autoCalFlowSelectFromDateEx";
export const GET_DT_SOURCE_WITH_COM = baseUrlMaster + "/getDTSourceWithCom";
export const GET_QTY_POINT_DATA = baseUrlInputManagement + "/getQtyPointData";
export const GET_LIST_DISTINCT_QTY_POINT = baseUrlInputManagement + "/getQtyPointDataEx";

export const GET_FLOW_DATA_MAX_MIN_10DAY = baseUrlFlowSelection + "/getFlowDataMaxMin10Day";
//FLOW SELECTION

//FLOW LOGIC
export const GET_FLOW_LOGIC = baseUrlMaster + "/getFlowLogic";
export const ADD_FLOW_LOGIC = baseUrlMaster + "/saveFlowLogic";
export const DELETE_FLOW_LOGIC = baseUrlMaster + "/delFlowLogic";
export const GET_DT_SOURCE = baseUrlMaster + "/getDTSource";
//FLOW LOGIC

//MANUAL DATA ENTRY => DIESEL & FUEL OIL DATA
// export const GET_DT_FUEL = baseUrlManualData + "/getDtFuel"
// export const GET_DT_DIESEL = baseUrlManualData + "/getDtDiesel"
// export const SAVE_DT_FUEL = baseUrlManualData + "/saveListDtFuel"
// export const SAVE_DT_DIESEL = baseUrlManualData + "/saveListDtDiesel"
// export const DEL_DT_FUEL = baseUrlManualData + "/delDtFuel"
// export const DEL_DT_DIESEL = baseUrlManualData + "/delDtDiesel"
//MANUAL DATA ENTRY => DIESEL & FUEL OIL DATA

//GAS VOLUME & LINE PACK

//OFFSHORE
export const GET_DT_OFFSHPRE_COLUMN = baseUrlManualData + "/getDtOffshoreColumn";
export const DEL_DT_OFFSHPRE_COLUMN = baseUrlManualData + "/delDtOffshoreColumn";
export const SAVE_DT_OFFSHPRE_COLUMN = baseUrlManualData + "/saveListDtOffshoreColumn";

export const GET_DT_OFFSHPRE = baseUrlManualData + "/getDtOffshore";
export const DEL_DT_OFFSHPRE = baseUrlManualData + "/delDtOffshore";
export const SAVE_DT_OFFSHPRE = baseUrlManualData + "/saveListDtOffshoreMod";
//OFFSHORE

//ONSHORE
export const GET_DT_ONSHORE_COLUMN = baseUrlManualData + "/getDtOnshoreColumn";
export const DEL_DT_ONSHORE_COLUMN = baseUrlManualData + "/delDtOnshoreColumn";
export const SAVE_DT_ONSHORE_COLUMN = baseUrlManualData + "/saveListDtOnshoreColumn";

export const GET_DT_ONSHORE = baseUrlManualData + "/getDtOnshore";
export const SAVE_DT_ONSHORE = baseUrlManualData + "/saveListDtOnshore";
export const DEL_DT_ONSHORE = baseUrlManualData + "/delDtOnshore";
export const GET_ONSHORE_REFRESH = baseUrlManualData + "/getOnShoreManualDataEntry"
//ONSHORE

//LINE PACK
export const GET_DT_LINEPACK_COLUMN = baseUrlManualData + "/getDtLinePackColumn";
export const DEL_DT_LINEPACK_COLUMN = baseUrlManualData + "/delDtLinePackColumn";
export const SAVE_DT_LINEPACK_COLUMN = baseUrlManualData + "/saveListDtLinePackColumn";

export const GET_DT_LINEPACK = baseUrlManualData + "/getDTLinePack";
export const SAVE_DT_LINEPACK = baseUrlManualData + "/saveListDTLinePack";
export const DEL_DT_LINEPACK = baseUrlManualData + "/delDTLinePack";

export const LOAD_DT_LINEPACK = baseUrlManualData + "/loadDtLinePackColumnApi";

//LINE PACK
//GAS VOLUME & LINE PACK

//OTHER KEY IN DATA
//DeliveryPlan
export const SAVE_DT_KEYIN_PLAN_MONTH = baseUrlManualData + "/saveListDtKeyinPlanMonth";
export const SAVE_DT_KEYIN_MAJOR_LOSS = baseUrlManualData + "/saveListDtKeyinMajorLoss";
export const SAVE_DT_KEYIN_MINOR_LOSS = baseUrlManualData + "/saveListDtKeyinMinorLoss";

export const GET_DT_KEYIN_PLAN_MONTH = baseUrlManualData + "/getDtKeyinPlanMonth";
export const GET_DT_KEYIN_MAJOR_LOSS = baseUrlManualData + "/getDtKeyinMajorLoss";
export const GET_DT_KEYIN_MINOR_LOSS = baseUrlManualData + "/getDtKeyinMinorLoss";
//DeliveryPlan

//PIPELINE CAPACITY

export const GET_DT_CAPACITY_COLUMN = baseUrlManualData + "/getDtKeyinCapacityColumn";
export const DEL_DT_CAPACITY_COLUMN = baseUrlManualData + "/delDtKeyinCapacityColumn";
export const SAVE_DT_CAPACITY_COLUMN = baseUrlManualData + "/saveListDtKeyinCapacityColumn";

export const GET_DT_CAPACITY = baseUrlManualData + "/getDtKeyinCapacity";
export const DEL_DT_CAPACITY = baseUrlManualData + "/delDtKeyinCapacity";
export const SAVE_DT_CAPACITY = baseUrlManualData + "/saveListDtKeyinCapacity";
//PIPELINE CAPACITY
//DEMAND

export const GET_DT_DEMAND_COLUMN = baseUrlManualData + "/getDtKeyinDemandColumn";
export const DEL_DT_DEMAND_COLUMN = baseUrlManualData + "/delDtKeyinDemandColumn";
export const SAVE_DT_DEMAND_COLUMN = baseUrlManualData + "/saveListDtKeyinDemandColumn";

export const GET_DT_DEMAND = baseUrlManualData + "/getDtKeyinDemand";
export const DEL_DT_DEMAND = baseUrlManualData + "/delDtKeyinDemand";
export const SAVE_DT_DEMAND = baseUrlManualData + "/saveListDtKeyinDemand";

export const GET_AVR_KEYIN_DEMAND = baseUrlManualData + "/getAverageKeyinDemand";
//DEMAND

//Performance
export const GET_DT_PERFORMANCE = baseUrlManualData + "/getDtKeyinPerformance";
export const DEL_DT_PERFORMANCE = baseUrlManualData + "/delDtKeyinPerformance";
export const SAVE_DT_PERFORMANCE = baseUrlManualData + "/saveListDtKeyinPerformance";
//Performance
//OTHER KEY IN DATA

//Flow/Fuel Oli ( Monthly & Daily )
//MONTHLY
export const GET_DT_MONTH_FLOW_COLUMN = baseUrlManualData + "/getDtMonthFlowColumn";
export const DEL_DT_MONTH_FLOW_COLUMN = baseUrlManualData + "/delDtMonthFlowColumn";
export const SAVE_DT_MONTH_FLOW_COLUMN = baseUrlManualData + "/saveListDtMonthFlowColumn";

export const GET_DT_MONTH_FLOW = baseUrlManualData + "/getDtMonthFlow";
export const DEL_DT_MONTH_FLOW = baseUrlManualData + "/delDtMonthFlow";
export const SAVE_DT_MONTH_FLOW = baseUrlManualData + "/saveListDtMonthFlow";

export const GET_DT_MONTH_FLOW_PLAN = baseUrlManualData + "/getDtMonthFlowPlan";
export const SAVE_DT_MONTH_FLOW_PLAN = baseUrlManualData + "/saveListDtMonthFlowPlan";
//MONTHLY
//Daily
export const GET_DT_DAILY_FLOW_COLUMN = baseUrlManualData + "/getDtDailyFlowColumn";
export const DEL_DT_DAILY_FLOW_COLUMN = baseUrlManualData + "/delDtDailyFlowColumn";
export const SAVE_DT_DAILY_FLOW_COLUMN = baseUrlManualData + "/saveListDtDailyFlowColumn";

export const GET_DT_DAILY_FLOW = baseUrlManualData + "/getDtDailyFlow";
export const DEL_DT_DAILY_FLOW = baseUrlManualData + "/delDtDailyFlow";
export const SAVE_DT_DAILY_FLOW = baseUrlManualData + "/saveListDtDailyFlow";

export const GET_DT_DAILY_FLOW_PLAN = baseUrlManualData + "/getDtDailyFlowPlan";
export const SAVE_DT_DAILY_FLOW_PLAN = baseUrlManualData + "/saveListDtDailyFlowPlan";
//Daily
//Flow/Fuel Oli ( Monthly & Daily )
//BALANCE
export const GET_DT_BALANCE_COLUMN = baseUrlManualData + "/getDtBalanceColumn";
export const DEL_DT_BALANCE_COLUMN = baseUrlManualData + "/delDtBalanceColumn";
export const SAVE_DT_BALANCE_COLUMN = baseUrlManualData + "/saveListDtBalanceColumn";
export const GET_DT_BALANCE_ZONE = baseUrlManualData + "/getDtBalanceZone";
export const DEL_DT_BALANCE_ZONE = baseUrlManualData + "/delDtBalanceZone";
export const SAVE_DT_BALANCE_ZONE = baseUrlManualData + "/saveListDtBalanceZone";
export const GET_DT_BALANCE_SHIPPER = baseUrlManualData + "/getDtBalanceShipper";
export const DEL_DT_BALANCE_SHIPPER = baseUrlManualData + "/delDtBalanceShipper";
export const SAVE_DT_BALANCE_SHIPPER = baseUrlManualData + "/saveListDtBalanceShipper";

export const AUTO_CAL_BALANCE_SHRINKAGE = baseUrlManualData + "/autoCalBalacingShrinkageFromFlowData";
export const GET_DT_BALANCE_ENERGY = baseUrlManualData + "/getDtBalanceEnergy";
export const SAVE_DT_BALANCE_ENERGY = baseUrlManualData + "/saveListDtBalanceEnergy";
export const DEL_DT_BALANCE_ENERGY = baseUrlManualData + "/delDtBalanceEnergy";
export const GET_DT_BALANCE_ZONE_ENERGY = baseUrlManualData + "/getDtBalanceZoneEnergy"
export const SAVE_DT_BALANCE_ZONE_ENERGY = baseUrlManualData + "/saveListDtBalanceZoneEnergy"

export const GET_DT_BALANCE_VOLUMN = baseUrlManualData + "/getDtBalanceVolumn";
export const SAVE_DT_BALANCE_VOLUMN = baseUrlManualData + "/saveListDtBalanceVolumn";
export const DEL_DT_BALANCE_VOLUMN = baseUrlManualData + "/delDtBalanceVolumn";
export const GET_DT_BALANCE_ZONE_VOLUMN = baseUrlManualData + "/getDtBalanceZoneVolumn"
export const SAVE_DT_BALANCE_ZONE_VOLUMN = baseUrlManualData + "/saveListDtBalanceZoneVolumn"

export const GET_DT_INVENTORY_ENERGY = baseUrlManualData + "/getDtInventoryEnergy";
export const SAVE_DT_INVENTORY_ENERGY = baseUrlManualData + "/saveListDtInventoryEnergy";
export const DEL_DT_INVENTORY_ENERGY = baseUrlManualData + "/delDtInventoryEnergy";
export const GET_DT_INVENTORY_ZONE_ENERGY = baseUrlManualData + "/getDtInventoryZoneEnergy"
export const SAVE_DT_INVENTORY_ZONE_ENERGY = baseUrlManualData + "/saveListDtInventoryZoneEnergy"
//BALANCE

//IMBALANCE
export const GET_DT_IMBALANCE_ENERGY = baseUrlManualData + "/getDtImbalanceEnergy";
export const SAVE_DT_IMBALANCE_ENERGY = baseUrlManualData + "/saveListDtImbalanceEnergy";
export const DEL_DT_IMBALANCE_ENERGY = baseUrlManualData + "/delDtImbalanceEnergy";
export const GET_DT_IMBALANCE_ZONE_ENERGY = baseUrlManualData + "/getDtImbalanceZoneEnergy"
export const SAVE_DT_IMBALANCE_ZONE_ENERGY = baseUrlManualData + "/saveListDtImbalanceZoneEnergy"
//IMBALANCE

//DIESEL
export const GET_DT_DIESEL_COLUMN = baseUrlManualData + "/getDtDieselColumn";
export const DEL_DT_DIESEL_COLUMN = baseUrlManualData + "/delDtDieselColumn";
export const SAVE_DT_DIESEL_COLUMN = baseUrlManualData + "/saveListDtDieselColumn";

export const GET_DT_DIESEL = baseUrlManualData + "/getDtDiesel";
export const SAVE_DT_DIESEL = baseUrlManualData + "/saveListDtDiesel";
export const DEL_DT_DIESEL = baseUrlManualData + "/delDtDiesel";
//DIESEL
//FUEL
export const GET_DT_FUEL_COLUMN = baseUrlManualData + "/getDtFuelColumn";
export const DEL_DT_FUEL_COLUMN = baseUrlManualData + "/delDtFuelColumn";
export const SAVE_DT_FUEL_COLUMN = baseUrlManualData + "/saveListDtFuelColumn";

export const GET_DT_FUEL = baseUrlManualData + "/getDtFuel";
export const SAVE_DT_FUEL = baseUrlManualData + "/saveListDtFuel";
export const DEL_DT_FUEL = baseUrlManualData + "/delDtFuel";
//FUEL

//FUEL
export const GET_DT_COMPOSITION_COLUMN = baseUrlManualData + "/getDtGasCompositionColumn";
export const DEL_DT_COMPOSITION_COLUMN = baseUrlManualData + "/delDtGasCompositionColumn";
export const SAVE_DT_COMPOSITION_COLUMN = baseUrlManualData + "/saveListDtGasCompositionColumn";
export const GET_DT_COMPOSITION_ROW = baseUrlManualData + "/getDtGasCompositionRow";
export const DEL_DT_COMPOSITION_ROW = baseUrlManualData + "/delDtGasCompositionRow";
export const SAVE_DT_COMPOSITION_ROW = baseUrlManualData + "/saveListDtGasCompositionRow";

export const GET_DT_COMPOSITION = baseUrlManualData + "/getDtGasComposition";
export const SAVE_DT_COMPOSITION = baseUrlManualData + "/saveListDtGasComposition";
export const DEL_DT_COMPOSITION = baseUrlManualData + "/delDtGasComposition";

export const LOAD_GAS_COMPOSITON = baseUrlManualData + "/loadDtGasCompositionApi";

export const GET_GC_GROUP = baseUrlMaster + "/getAllGCGroupCboList";


//FUEL

//ALARM REPORT
export const GET_ALARM_DATA = baseUrlAlarmReport + "/getAlarmData";
export const SAVE_ALARM_DATA = baseUrlAlarmReport + "/saveAlarmData";
export const SAVE_LIST_ALARM_DATA = baseUrlAlarmReport + "/saveListAlarmData";
export const MANUAL_REFRESH_ALARM = baseUrlAlarmReport + "/loadToalAlarmPrevDay";
//ALARM REPORT

//USER MANAGEMENT

//ROLE MANAGEMENT
export const GET_ROLE_DATA = baseUrlAccount + "/getRole";
export const SAVE_ROLE = baseUrlAccount + "/saveRole";
export const DELETE_ROLE = baseUrlAccount + "/delRole";
//ROLE MANAGEMENT

//USER MANAGEMENT
export const GET_ACCOUNT = baseUrlAccount + "/getAccount";
export const SAVE_ACCOUNT = baseUrlAccount + "/saveAccount";
export const DELETE_ACCOUNT = baseUrlAccount + "/delAccount";
//USER MANAGEMENT

//USER MANAGEMENT

//SUMMARY REPORT


export const GET_RP_SUMMARY_REPORT = baseUrlSummaryReport + "/getRPSummaryReport";

export const GET_RP_AVG_DEMAND_YEAR_TO_TODAY = baseUrlSummaryReport + "/getRPAVGDemandEventOfYearToToday";

export const GET_RP_SUPPLY_DEMAND_ENTRY = baseUrlSummaryReport + "/getRPSupplyDemandEntry";
export const SAVE_RP_SUPPLY_DEMAND_ENTRY = baseUrlSummaryReport + "/saveRPSupplyDemandEntry";
export const GET_RP_SUPPLY_DEMAND_EXIT = baseUrlSummaryReport + "/getRPSupplyDemandExit";
export const SAVE_RP_SUPPLY_DEMAND_EXIT = baseUrlSummaryReport + "/saveRPSupplyDemandExit";
export const GET_RP_SUPPLY_DEMAND = baseUrlSummaryReport + "/getRPSupplyDemand";

export const GET_RP_SUPPLY_ENTRY = baseUrlSummaryReport + "/getRPSupplyEntry";
export const GET_RP_DEMAND_EXIT = baseUrlSummaryReport + "/getRPDemandExit";
export const GET_RP_ACTIVITY_ENTRY = baseUrlSummaryReport + "/getRPActivityEntry";
export const GET_RP_ACTIVITY_EXIT = baseUrlSummaryReport + "/getRPActivityExit";

export const GET_RP_AVG_DEMAND = baseUrlSummaryReport + "/getRPAVGDemand";
export const GET_RP_AVG_DEMAND_EVENT = baseUrlSummaryReport + "/getRPAVGDemandEvent";
export const SAVE_RP_AVG_DEMAND_EVENT = baseUrlSummaryReport + "/saveRPAVGDemandEvent";

export const GET_RP_OVERUSE_SHIPPER = baseUrlSummaryReport + "/getRPOveruseShipper";
export const GET_RP_OVERUSE_CODE = baseUrlSummaryReport + "/getRPOveruseCode";
export const GET_RP_OVERUSE_CODE_DATA = baseUrlSummaryReport + "/getRPOveruseCodeData";


//SUMMARY REPORT

//API SCHEDULE
export const GET_API_SCHEDULE = baseUrlMaster + "/getApiSchedule";
export const ADD_API_SCHEDULE = baseUrlMaster + "/saveApiSchedule";
export const DELETE_API_SCHEDULE = baseUrlMaster + "/delApiSchedule";
export const SAVE_LIST_API_SCHEDULE = baseUrlMaster + "/saveListApiSchedule";
//API SCHEDULE

// DASH BOARD URL
export const GET_DASHBOARD_URL = baseUrlMaster + "/getDashboardConfig";
export const SAVE_DASHBOARD_URL = baseUrlMaster + "/saveDashboardConfig";
export const DELETE_DASHBOARD_URL = baseUrlMaster + "/delDashboardConfig";
export const SAVE_LIST_DASHBOARD_URL = baseUrlMaster + "/saveListDashboardConfig";
export const GET_DIVISION = baseUrlAccount + "/getDivisionAccount";
// DASH BOARD URL

//API PMIS PARAMETER 
export const GET_API_PARAMETER = baseUrlMaster + "/getApiParameter";
export const SAVE_API_PARAMETER = baseUrlMaster + "/saveApiParameter";
export const DELETE_API_PARAMETER = baseUrlMaster + "/delApiParameter";
export const SAVE_LIST_API_PARAMETER = baseUrlMaster + "/saveListApiParameter";
//API PMIS PARAMETER 

//SECTION BALANCE IN PAGE SUMMARY REPORT

export const GET_RP_BALANCE = baseUrlSummaryReport + "/getRPBalancing";
export const SAVE_RP_BALANCE = baseUrlSummaryReport + "/saveListRPBalancing";
//DIALOG TOTAL
export const SAVE_RP_BALANCE_TOTAL = baseUrlSummaryReport + "/saveRPBalancingTotal";
export const SAVE_LIST_RP_BALANCE_TOTAL = baseUrlSummaryReport + "/saveListRPBalancingTotal";
export const DELETE_RP_BALANCE_TOTAL = baseUrlSummaryReport + "/delRPBalancingTotal";
export const GET_RP_BALANCE_TOTAL = baseUrlSummaryReport + "/getRPBalancingTotal";
//DIALOG TOTAL

//DIALOG EAST
export const SAVE_RP_BALANCE_EAST = baseUrlSummaryReport + "/saveRPBalancingEast";
export const SAVE_LIST_RP_BALANCE_EAST = baseUrlSummaryReport + "/saveListRPBalancingEast";
export const DELETE_RP_BALANCE_EAST = baseUrlSummaryReport + "/delRPBalancingEast";
export const GET_RP_BALANCE_EAST = baseUrlSummaryReport + "/getRPBalancingEast";
//DIALOG EAST

//DIALOG WEST
export const SAVE_RP_BALANCE_WEST = baseUrlSummaryReport + "/saveRPBalancingWest";
export const SAVE_LIST_RP_BALANCE_WEST = baseUrlSummaryReport + "/saveListRPBalancingWest";
export const DELETE_RP_BALANCE_WEST = baseUrlSummaryReport + "/delRPBalancingWest";
export const GET_RP_BALANCE_WEST = baseUrlSummaryReport + "/getRPBalancingWest";
//DIALOG WEST

//SECTION BALANCE IN PAGE SUMMARY REPORT

//SECTION COMPRESSOR FUEL CONSUMPTION IN PAGE SUMMARY REPORT

//DIALOG CRITERIA
export const SAVE_RP_FUEL_CRITERIA = baseUrlSummaryReport + "/saveRPFuelCriteria";
export const SAVE_LIST_FUEL_CRITERIA = baseUrlSummaryReport + "/saveListRPFuelCriteria";
export const DELETE_RP_FUEL_CRITERIA = baseUrlSummaryReport + "/delRPFuelCriteria";
export const GET_RP_FUEL_CRITERIA = baseUrlSummaryReport + "/getRPFuelCriteria";
//DIALOG CRITERIA

//TABLE CONSUMPTION
export const SAVE_RP_FUEL_CONSUMPTION = baseUrlSummaryReport + "/saveRPFuelConsumption";
export const SAVE_LIST_FUEL_CONSUMPTION = baseUrlSummaryReport + "/saveListRPFuelConsumption";
export const DELETE_RP_FUEL_CONSUMPTION = baseUrlSummaryReport + "/delRPFuelConsumption";
export const GET_RP_FUEL_CONSUMPTION = baseUrlSummaryReport + "/getRPFuelConsumption";
//TABLE CONSUMPTION


//SECTION COMPRESSOR FUEL CONSUMPTION IN PAGE SUMMARY REPORT

//SECTION QUALITY IN PAGE SUMMARY REPORT
export const SAVE_RP_QUALITY = baseUrlSummaryReport + "/saveRPQuality";
export const SAVE_LIST_RP_QUALITY = baseUrlSummaryReport + "/saveListRPQuality";
export const DELETE_RP_QUALITY = baseUrlSummaryReport + "/delRPQuality";
export const GET_RP_QUALITY = baseUrlSummaryReport + "/getRPQuality";
//SECTION QUALITY IN PAGE SUMMARY REPORT

//SECTION BALANCING IN PAGE SUMMARY REPORT
export const SAVE_RP_BALANCE_EVENT = baseUrlSummaryReport + "/saveRPBalancingEvent";
export const SAVE_LIST_RP_BALANCE_EVENT = baseUrlSummaryReport + "/saveListRPBalancingEvent";
export const DELETE_RP_BALANCE_EVENT = baseUrlSummaryReport + "/delRPBalancingEvent";
export const GET_RP_BALANCE_EVENT = baseUrlSummaryReport + "/getRPBalancingEvent";
//SECTION BALANCING IN PAGE SUMMARY REPORT

//SECTION ALARM IN PAGE SUMMARY REPORT
export const SAVE_RP_ALARM = baseUrlSummaryReport + "/saveRPAlarm";
export const SAVE_LIST_RP_ALARM = baseUrlSummaryReport + "/saveListRPAlarm";
export const DELETE_RP_ALARM = baseUrlSummaryReport + "/delRPAlarm";
export const GET_RP_ALARM = baseUrlSummaryReport + "/getRPAlarm";
//SECTION ALARM IN PAGE SUMMARY REPORT

//SECTION SUMMARY ALARM IN PAGE SUMMARY REPORT
export const SAVE_RP_SUMMARY_ALARM = baseUrlSummaryReport + "/saveRPAlarmSummary";
export const SAVE_LIST_RP_SUMMARY_ALARM = baseUrlSummaryReport + "/saveListRPAlarmSummary";
export const DELETE_RP_SUMMARY_ALARM = baseUrlSummaryReport + "/delRPAlarmSummary";
export const GET_RP_SUMMARY_ALARM = baseUrlSummaryReport + "/getRPAlarmSummary";
//SECTION SUMMARY ALARM IN PAGE SUMMARY REPORT

//SECTION  BY PASS GAS IN PAGE SUMMARY REPORT
export const SAVE_RP_BY_PASS_GAS = baseUrlSummaryReport + "/saveRPBypassGas";
export const SAVE_LIST_RP_BY_PASS_GAS = baseUrlSummaryReport + "/saveListRPBypassGas";
export const DELETE_RP_BY_PASS_GAS = baseUrlSummaryReport + "/delRPBypassGas";
export const GET_RP_BY_PASS_GAS = baseUrlSummaryReport + "/getRPBypassGas";
//SECTION  BY PASS GAS IN PAGE SUMMARY REPORT

//PUBLIC SUMMARY REPORT
export const PUBLIC_SUMMARY_REPORT = baseUrlSummaryReport + "/publicRPSummaryReport";
export const PUBLIC_ALLOCATE_SUMMARY_REPORT = baseUrlSummaryReport + "/publicAllocateRPSummaryReport";
//PUBLIC SUMMARY REPORT

//DAILY DASH BOARD
//FILE INDEX
export const GET_PUBLIC_REPORT = baseUrlSummaryReport + "/getPublicReport";
//FILE INDEX
//DAILY DASH BOARD


//REPORT
// TPA DAILY REPORT
export const SAVE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveRPTPADaily";
export const SAVE_LIST_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveListRPTPADaily";
export const DELETE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/delRPTPADaily";
export const GET_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/getRPTPADaily";
export const RP_TPA_SEND_MAIL = baseUrlSummaryReport + "/sendMailTpaReport"

export const SAVE_ONSHORE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveRPTPAOnshore";
export const SAVE_LIST_ONSHORE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveListRPTPAOnshore";
export const DELETE_ONSHORE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/delRPTPAOnshore";
export const GET_ONSHORE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/getRPTPAOnshore";

export const SAVE_STOCK_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveRPTPAStock";
export const SAVE_LIST_STOCK_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveListRPTPAStock";
export const DELETE_STOCK_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/delRPTPAStock";
export const GET_STOCK_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/getRPTPAStock";

export const SAVE_EVENT_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveRPTPAEvent";
export const SAVE_LIST_EVENT_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveListRPTPAEvent";
export const DELETE_EVENT_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/delRPTPAEvent";
export const GET_EVENT_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/getRPTPAEvent";

export const SAVE_SHRINKAGE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveRPTPAShrinkage";
export const SAVE_LIST_SHRINKAGE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/saveListRPTPAShrinkage";
export const DELETE_SHRINKAGE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/delRPTPAShrinkage";
export const GET_SHRINKAGE_RP_TPA_DAILY_REPORT = baseUrlSummaryReport + "/getRPTPAShrinkage";
// TPA DAILY REPORT

//GAS COMPOSITION REPORT
export const SAVE_RP_GC_DAILY_REPORT = baseUrlSummaryReport + "/saveRPGCDaily";
export const SAVE_LIST_RP_GC_DAILY_REPORT = baseUrlSummaryReport + "/saveListRPGCDaily";
export const DELETE_RP_GC_DAILY_REPORT = baseUrlSummaryReport + "/delRPGCDaily";
export const GET_RP_GC_DAILY_REPORT = baseUrlSummaryReport + "/getRPGCDaily";
export const GET_REPORT_GAS_COMPOSITION = baseUrlSummaryReport + "/getReportGasComposition";
export const SEND_E_MAIL_GAS_COMPOSITION = baseUrlSummaryReport + "/sendMailGCReport";
//GAS COMPOSITION REPORT

//EOD DAILY REPORT
export const GET_EOD_DAILY_REPORT = baseUrlSummaryReport + "/getEODReportConf";
export const SEND_MAIL_EOD_REPORT = baseUrlSummaryReport + "/sendMailEODReport";
//EOD DAILY REPORT

//ACTUAL SUPPLY DEMAND ( ACTUAL-GSM )
export const GET_ACTUAL_SUPPLY_DEMAND_REPORT = baseUrlFlowSelection + "/getActiveFlowData";
export const GET_DETAIL_ACTUAL_SUPPLY_DEMAND_REPORT = baseUrlSummaryReport + "/getRPActualGSMEx";
export const SEND_MAIL_ACTUAL_SUPPLY_DEMAND = baseUrlSummaryReport + "/sendMailRPActualSupplyDemand";
//ACTUAL SUPPLY DEMAND ( ACTUAL-GSM )

//GAS DELIVERY PERFORMANCE
export const GET_RP_GAS_PERFORMANCE_REPORT = baseUrlSummaryReport + "/getRPPerformance";
export const GET_DETAIL_GAS_PERFORMANCE_REPORT = baseUrlSummaryReport + "/getRPPerformanceEx"
export const SEND_MAIL_GAS_PERFORMANCE_REPORT = baseUrlSummaryReport + "/sendMailPerformanceReport";
//GAS DELIVERY PERFORMANCE

//DELIVERY GAS FUEL GAS REPORT
export const GET_RP_GAS_DELIVERY_FUEL = baseUrlSummaryReport + "/getRPDeliveryFuel";
export const SAVE_RP_GAS_DELIVERY_FUEL = baseUrlSummaryReport + "/saveRPDeliveryFuel";
export const SAVE_LIST_RP_GAS_DELIVERY_FUEL = baseUrlSummaryReport + "/saveListRPDeliveryFuel";
export const GET_RP_DETAIL_GAS_DELIVERY_FUEL = baseUrlSummaryReport + "/getRPDeliveryFuelEx";
export const SEND_MAIL_GAS_DELIVERY_FUEL = baseUrlSummaryReport + "/sendMailRPGasDeliveryFuel";
//DELIVERY GAS FUEL GAS REPORT

//AVERAGE GAS DELIVERY REPORT
export const GET_RP_DETAIL_AVG_GAS_DELIVERY = baseUrlSummaryReport + "/getRPGasDeliveryAvgEx";
export const SEND_MAIL_AVG_GAS_DELIVERY = baseUrlSummaryReport + "/sendMailRPGasDeliveryAvg";
//AVERAGE GAS DELIVERY REPORT

//TPA BALANCING && OVERUSE
export const GET_RP_TPA_BALANCE_OVERUSE = baseUrlSummaryReport + "/getRPTPABalancing";
export const SAVE_RP_TPA_BALANCE_OVERUSE = baseUrlSummaryReport + "/saveRPTPABalancing";
export const SAVE_LIST_RP_TPA_BALANCE_OVERUSE = baseUrlSummaryReport + "/saveListRPTPABalancing";
export const DELETE_RP_TPA_BALANCE_OVERUSE = baseUrlSummaryReport + "/delRPTPABalancing";
export const SEND_MAIL_TPA_BALANCE = baseUrlSummaryReport + "/sendMailTPABalancingReport";
//TPA BALANCING && OVERUSE

//SHIFT REPORT
export const GET_SHIFT_DAILY_REPORT = baseUrlSummaryReport + "/getShiftReportConf";
export const SEND_MAIL_SHIFT_REPORT = baseUrlSummaryReport + "/sendMailShiftReport";
export const GET_DETAIL_SHIFT_DATA = baseUrlSummaryReport + "/getShiftData";
export const SAVE_RP_SHIFT = baseUrlSummaryReport + "/saveRPShift";
export const GET_RP_SHIFT = baseUrlSummaryReport + "/getRPShift";
export const REFRESH_RP_SHIFT_DATA = baseUrlSummaryReport + "/reloadRPShiftData";
export const SAVE_LIST_RP_SHIFT_DATA_REPORT = baseUrlSummaryReport + "/saveListRPShiftData";
//SHIFT REPORT

//PIPELINE UTILIZATION REPORT
export const GET_RP_PIPELINE = baseUrlSummaryReport + "/getRPPipeline";
export const SEND_MAIL_PIPELINE_REPORT = baseUrlSummaryReport + "/sendMailPipelineReport";
//PIPELINE UTILIZATION REPORT

//BI DASHBOARD
export const GET_ACTIVE_DASHBOARD = baseUrlMaster + "/getActiveDashboardConfig";
//BI DASHBOARD

//E MAIL MANAGEMENT
export const SAVE_EMAIL_REPORT = baseUrlMaster + "/saveEmailReport";
export const SAVE_LIST_EMAIL_REPORT = baseUrlMaster + "/saveListEmailReport";
export const DELETE_EMAIL_REPORT = baseUrlMaster + "/delEmailReport";
export const GET_EMAIL_REPORT = baseUrlMaster + "/getEmailReport";

export const GET_EMAIL_BY_PTT = baseUrlAccount + "/getPersonnelInfoEx";
//E MAIL MANAGEMENT